import { Component, Input } from "@angular/core";

// Gedeelde Microsoft-knop (de afgeronde witte SVG met het vierkleurige logo). Enkel het
// visuele deel — de parent bepaalt de interactie (een <a href> voor login, een <button>
// met click-handler voor de koppelflow). Zo staat de SVG maar op één plek.
@Component({
  selector: "app-microsoft-button",
  templateUrl: "./microsoft-button.component.html",
  standalone: true,
})
export class MicrosoftButtonComponent {
  @Input() label = "Aanmelden met Microsoft";
}
